import { matchIsValidTel } from 'mui-tel-input';
import * as Yup from 'yup';
import { maxValidationString, minValidationString, requiredField } from '../../helperFuncs';

export const CreateUserValidation = Yup.object({
  // step1
  first_name:
    Yup.string()
      .required('Συμπληρώστε το πεδίο')
      .min(1, 'Ελάχιστο επιτρεπόμενο πλήθος χαρακτήρων: 1')
      .max(40, 'Μέγιστο επιτρεπόμενο πλήθος χαρακτήρων: 40')
      .matches(/^[Α-ΩA-Zα-ωa-zάέήίόύώϊϋΐΰ]+(?: [Α-ΩA-Zα-ωa-zάέήίόύώϊϋΐΰ]+)*$/, 'Παρακαλούμε συμπληρώστε το πεδίο μόνο με ελληνικούς ή λατινικούς χαρακτήρες'),
  last_name:
    Yup.string()
      .required('Συμπληρώστε το πεδίο')
      .min(1, 'Μέγιστο Ελάχιστο πλήθος χαρακτήρων: 1')
      .max(50, 'Μέγιστο επιτρεπόμενο πλήθος χαρακτήρων: 50')
      .matches(/^[Α-ΩA-Zα-ωa-zάέήίόύώϊϋΐΰ]+(?: [Α-ΩA-Zα-ωa-zάέήίόύώϊϋΐΰ]+)*$/, 'Παρακαλούμε συμπληρώστε το πεδίο μόνο με ελληνικούς ή λατινικούς χαρακτήρες'),
  // step2
  email:
    Yup.string()
      .required('Συμπληρώστε το πεδίο')
      .email('Μη αποδεκτή μορφή Email')
      .matches(/^\w+([.-]?\w+)*@\w+([-]?\w+)*(\.\w{2,}(?!\.\w))$/, 'Μη αποδεκτή μορφή Email'),
  phone_number: Yup.string()
    .required(requiredField)
    .nullable()
    .test('phone_number', 'Παρακαλώ προσθέστε έγκυρη μορφή τηλεφώνου', (value) => matchIsValidTel(value || '')),
  // step3
  afm: Yup.string()
    .nullable()
    .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
    .min(9, minValidationString(9))
    .max(9, maxValidationString(9)),
  roles:
    Yup.array()
      .required(requiredField)
      .test('arrayLength', 'Παρακαλώ επιλέξτε τουλάχιστον έναν Ρόλο', (value) => {
        if (!value) return true;
        return value?.length > 0;
      }),
  administrative_unit_id:
    Yup.string()
      .required()
      .nullable()
      .required('Συμπληρώστε το πεδίο'),
  is_enabled:
    Yup.boolean()
      .required('Συμπληρώστε το πεδίο')
});